import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect(){
    window.addEventListener("load", async () => {
      // check if the browser supports serviceWorker at all
      if (!("serviceWorker" in navigator)) {
        console.log("Your browser doesn't support service workers 🤷‍♀️");
        return;
      }

      // The service worker's StaleWhileRevalidate cache serves the previous bundle after a local rebuild.
      if (this.isLocalDevelopment) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
        return;
      }

      // eslint-disable-next-line no-unused-vars
      const registration = await navigator.serviceWorker.register('/service-worker.js', { scope: "/", updateViaCache: "none" });
    });
  }

  get isLocalDevelopment() {
    const { hostname } = window.location;
    return hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname.endsWith(".test") ||
      hostname.endsWith(".localhost");
  }
}
